import { useState, useEffect } from 'react';
import api from '@/lib/api';
import { Card, CardContent } from '@/components/ui/card';
import { BarChart3, ShoppingCart, Users, Package, TrendingUp, DollarSign } from 'lucide-react';

export default function TenantReports() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get('/tenant/reports').then(r => setData(r.data)).catch(() => {}); }, []);
  const fmt = (v) => new Intl.NumberFormat('id-ID').format(v || 0);

  return (
    <div data-testid="tenant-reports-page">
      <h1 className="text-2xl font-bold tracking-tight text-slate-900 mb-6" style={{ fontFamily: 'Plus Jakarta Sans' }}>Laporan</h1>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8">
        <Card className="stat-card"><CardContent className="p-5">
          <DollarSign size={20} className="text-[#2D6CDF] mb-2" /><p className="text-2xl font-bold">Rp {fmt(data?.total_revenue)}</p><p className="text-xs text-slate-500">Total Revenue</p>
        </CardContent></Card>
        <Card className="stat-card"><CardContent className="p-5">
          <ShoppingCart size={20} className="text-emerald-500 mb-2" /><p className="text-2xl font-bold">{data?.total_orders || 0}</p><p className="text-xs text-slate-500">Total Pesanan</p>
        </CardContent></Card>
        <Card className="stat-card"><CardContent className="p-5">
          <Users size={20} className="text-violet-500 mb-2" /><p className="text-2xl font-bold">{data?.total_customers || 0}</p><p className="text-xs text-slate-500">Total Pelanggan</p>
        </CardContent></Card>
        <Card className="stat-card"><CardContent className="p-5">
          <Package size={20} className="text-amber-500 mb-2" /><p className="text-2xl font-bold">{data?.total_products || 0}</p><p className="text-xs text-slate-500">Total Produk</p>
        </CardContent></Card>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <Card className="border-slate-200 shadow-sm"><CardContent className="p-6">
          <h3 className="font-semibold text-slate-900 mb-4">Produk per Tipe</h3>
          {(data?.product_types || []).map((pt, i) => (
            <div key={i} className="flex justify-between py-2 border-b border-slate-50 text-sm">
              <span className="capitalize text-slate-600">{pt._id || 'unknown'}</span>
              <span className="font-medium">{pt.count}</span>
            </div>
          ))}
          {!data?.product_types?.length && <p className="text-center text-slate-400 py-4">Tidak ada data</p>}
        </CardContent></Card>
        <Card className="border-slate-200 shadow-sm"><CardContent className="p-6">
          <h3 className="font-semibold text-slate-900 mb-4">Order per Status</h3>
          {(data?.order_statuses || []).map((os, i) => (
            <div key={i} className="flex justify-between py-2 border-b border-slate-50 text-sm">
              <span className="capitalize text-slate-600">{os._id || 'unknown'}</span>
              <span className="font-medium">{os.count}</span>
            </div>
          ))}
          {!data?.order_statuses?.length && <p className="text-center text-slate-400 py-4">Tidak ada data</p>}
        </CardContent></Card>
      </div>
    </div>
  );
}
